import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { MessageBar } from 'office-ui-fabric-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { SelectionMode } from 'office-ui-fabric-react/lib/Utilities';
import React, { Component, Fragment } from 'react';
import ImmocomContext from '../../contexts/ImmocomContext';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataTicket } from '../../data/DataTicket';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxDomaine } from '../ComboBox/ComboBoxDomaine';
import { ComboBoxEtat } from '../ComboBox/ComboBoxEtat';
import { ComboBoxFonctionnalite } from '../ComboBox/ComboBoxFonctionnalite';
import { ComboBoxSalariesScribaNet } from '../ComboBox/ComboBoxSalariesScribaNet';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUIPanel } from '../EUI/EUIPanel';
import { FicheEnvoiEmail } from '../Fiche/FicheEnvoiEmail';
import { FicheTache } from '../Fiche/FicheTache';
import { FicheTicket } from '../Fiche/FicheTicket';
import { DetailsListTache } from '../List/DetailsListTache';

export class DetailsListTicket extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListTicketWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

// KP - 26/06/2023 : composant raccordé à ImmocomContext pour tests
class DetailsListTicketWithPerimetre extends Component {

    static contextType = ImmocomContext;

    static defaultProps = {
        idTache: undefined,
        perimetre: {}
    };

    static defaultState = {
        dialogAssignerASelectedOption: { key: "0", text: "Indéfini" },
        dialogEtatSelectedOption: { key: 0, text: "Indéfini" },
        idTacheSelectionne: 0,
        idTicket: 0,
        itemActif: {},
        items: [],
        itemsSelectionnes: [],
        statutSelectionne: undefined,
        /* --- */
        afficherDialogAssignerA: false,
        afficherDialogDesaffecter: false,
        afficherDialogEtat: false,
        afficherDialogStatut: false,
        afficherDialogSuppressionTicket: false,
        afficherPanelEnvoiEmail: false,
        afficherPanelFiltres: false,
        afficherPanelSelectionProjet: false,
        afficherPanelTache: false,
        afficherPanelTicket: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListTicketWithPerimetre.defaultState };
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = true;
        this._sortedColumn = "idTicket";
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this._togglePanel("Filtres", false, null, this._chargementDonnees)();
    };

    _chargementDonnees = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement des tickets en cours...");

        const { idTache } = this.props;
        const filtres = { ...this._filtres, idTache };
        const tri = `${this._sortedColumn} ${this._isSortedDescending ? "DESC" : "ASC"}`;

        DataTicket._chargementListeDesTicketsDeLaTache(filtres, tri, -1).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let tickets = responseFetch.reponseAPIobjet || [];
                tickets = tickets.map(ticket => {
                    const { description } = ticket;
                    let updatedTicket = { ...ticket };
                    if (!!description) {
                        const draft = htmlToDraft(description);
                        const { contentBlocks, entityMap } = draft;
                        const content = ContentState.createFromBlockArray(contentBlocks, entityMap);
                        updatedTicket.description = EditorState.createWithContent(content).getCurrentContent().getPlainText();
                    }
                    return updatedTicket;
                });

                const state = { items: tickets };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                fetchMessages(responseFetch);
                this.setState({ items: [] });
            }
            dismissMessage(messageId);
        });

    };

    _dissocierTicketsDeProjet = () => {
        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Dissociation des tickets en cours...");

        const listIdTicket = this._getListIdTicketSelectionnes();
        /* 20230306 : YD : renommage DesactivationTicket en DossiociationTicket */
        DataTicket._onEnregistrementDissociationTicket(listIdTicket).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });
    };

    _getColumns = () => {

        const { idTache } = this.props;
        const styles = { fontSize: "20px", textAlign: "center", verticalAlign: "middle" };

        let columns = [{
            key: "idTicket",
        }, {
            key: "description",
            name: 'Description',
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: "loginCompte",
            minWidth: 80,
            maxWidth: 100,
            name: 'Login compte',
        }, {
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            key: "nomSociete",
            maxWidth: 80,
            minWidth: 60,
            name: 'Société',
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: "domaine",
            maxWidth: 80,
            minWidth: 80,
            name: 'Domaine',
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: "fonctionnalite",
            maxWidth: 80,
            minWidth: 80,
            name: 'Fonctionnalite',
        }];

        if (!idTache) {
            columns.push({
                key: "idTache",
                name: 'IdTache',
                onRender: (item) => <Link onClick={this._togglePanel("Tache", true, item)}>{item.idTache}</Link>
            });
        }

        columns = columns.concat([{
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            key: "creerLe",
            name: 'Créé le'
        }, {
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            key: "modifierLe",
            name: 'Modifié le',
        }, {
            className: 'ms-hiddenSm',
            headerClassName: 'ms-hiddenSm',
            key: "prioriteOrdre",
            maxWidth: 60,
            minWidth: 60,
            name: 'Priorité',
            onRender: (item) => {
                let prioriteOrdre = item.prioriteOrdre;
                let classBadge = null;
                let prioriteOrdreString = "";
                switch (prioriteOrdre) {
                    case 0:
                        classBadge = "success";
                        prioriteOrdreString = "Basse";
                        break;
                    case 1:
                        classBadge = "warning";
                        prioriteOrdreString = "Médium";
                        break;
                    case 2:
                        classBadge = "danger";
                        prioriteOrdreString = "Haute";
                        break;
                    default:
                        classBadge = "secondary";
                        break;
                }

                return <span title={prioriteOrdre} className={"badgePriorite badge badge-" + classBadge}>{prioriteOrdreString}</span>;
            }
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: "etat",
            minWidth: 125,
            maxWidth: 125,
            name: 'État',
        }, {
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            key: "assigneA",
            minWidth: 80,
            maxWidth: 100,
            name: 'Assigné à',
        }, {
            isIconOnly: true,
            key: "ouvert",
            onRender: (item) => {
                const ouvert = item.ouvert;
                if (ouvert) return <Icon iconName="BoxCheckmarkSolid" styles={{ root: { ...styles, color: "#107c10" } }} title="Ouvert" />;
                else return <Icon iconName="BoxMultiplySolid" styles={{ root: { ...styles, color: "#ed1920" } }} title="Fermé" />;
            }
        }, {
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            isIconOnly: true,
            key: "nomFileData",
            onRender: (item) => {
                const nomFileData = item.nomFileData;
                if (!!nomFileData) return <Icon iconName="Picture" styles={{ root: styles }} title="Capture d'écran fournie" />;
            }
        }, {
            ariaLabel: 'Modifier le ticket',
            isIconOnly: true,
            key: 'edition',
            onRender: (item) => {
                return <IconButton
                    ariaLabel="Modifier le ticket"
                    iconProps={{ iconName: 'Edit' }}
                    onClick={this._togglePanel("Ticket", true, item)}
                    title="Modifier le ticket"
                />;
            }
        }, {
            ariaLabel: 'Supprimer le ticket',
            isIconOnly: true,
            key: 'delete',
            onRender: (item) => {
                return <IconButton
                    ariaLabel="Suppression"
                    iconProps={{ iconName: 'Delete' }}
                    onClick={this._toggleDialog("SuppressionTicket", true, item)}
                    title="Supprimer le ticket"
                />;
            }
        }]);

        return columns;
    };

    _getFiltres = () => {
        return { ...PanelFiltres.defaultState };
    };

    _getItems = () => {

        const { idTache } = this.props;
        const { itemsSelectionnes } = this.state;

        return [{
            key: "nouveau",
            name: "Nouveau Ticket",
            iconProps: { iconName: "Add" },
            onClick: this._togglePanel("Ticket", true, { idTicket: 0, idTache })
        }, {
            key: "actions",
            disabled: itemsSelectionnes.length == 0,
            name: "Actions",
            iconProps: { iconName: "SetAction" },
            subMenuProps: {
                items: [{
                    iconProps: { iconName: "Mail" },
                    key: "emailMessage",
                    name: "Email message",
                    onClick: this._togglePanel("EnvoiEmail", true)
                }, {
                    iconProps: { iconName: "Link" },
                    key: "lier",
                    name: "Lier projet",
                    onClick: this._togglePanel("SelectionProjet", true)
                }, {
                    disabled: itemsSelectionnes.some(ticket => !ticket.idTache),
                    iconProps: { iconName: "Link" },
                    key: "dissocier",
                    name: "Dissocier projet",
                    onClick: this._toggleDialog("Desaffecter", true)
                }, {
                    iconProps: { iconName: "UserSync" },
                    key: "modifierAssignation",
                    name: "Modifier l'assignation",
                    onClick: this._toggleDialog("AssignerA", true)
                }, {
                    iconProps: { iconName: "Clock" },
                    key: "modifierEtat",
                    name: "Modifier l'état",
                    onClick: this._toggleDialog("Etat", true)
                }, {
                    disabled: itemsSelectionnes.some(ticket => !ticket.ouvert),
                    iconProps: { iconName: "StatusCircleErrorX" },
                    key: "cloturer",
                    name: "Clôturer",
                    onClick: () => this.setState({ statutSelectionne: "ferme" }, this._toggleDialog("Statut", true))
                }, {
                    disabled: itemsSelectionnes.some(ticket => ticket.ouvert),
                    iconProps: { iconName: "StatusCircleCheckmark" },
                    key: "ouvrir",
                    name: "Ouvrir",
                    onClick: () => this.setState({ statutSelectionne: "ouvert" }, this._toggleDialog("Statut", true))
                }]
            }
        }];

    };

    _getListIdTicketSelectionnes = () => {
        return this.state.itemsSelectionnes
            .map(ticket => ticket.idTicket)
            .join(";#");
    };

    _lierTicketsAProjet = () => {
        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Liaison des tickets en cours...");

        const listIdTicket = this._getListIdTicketSelectionnes();
        const { idTacheSelectionne } = this.state;

        DataTicket._onEnregistrementRaccrochementTicketsATache(idTacheSelectionne, listIdTicket).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const state = { idTacheSelectionne: 0 };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._chargementDonnees);
            }
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });
    };

    _modifierAssignationTickets = () => {
        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Réassignation des tickets en cours...");

        const listIdTicket = this._getListIdTicketSelectionnes();
        const { dialogAssignerASelectedOption } = this.state;

        DataTicket._onEnregistrementAssignationTicket(dialogAssignerASelectedOption.key, listIdTicket).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const state = { dialogAssignerASelectedOption: { key: '0', text: "Indéfini" } };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._chargementDonnees);
            }
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });
    };

    _modifierEtatTickets = () => {
        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Mise à jour des tickets en cours...");

        const listIdTicket = this._getListIdTicketSelectionnes();
        const { dialogEtatSelectedOption } = this.state;

        DataTicket._onEnregistrementEtatTicket(dialogEtatSelectedOption.key, listIdTicket).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const state = { dialogEtatSelectedOption: { key: 0, text: "Indéfini" } };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._chargementDonnees);
            }
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });
    };

    _modifierStatutTickets = () => {
        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Mise à jour des tickets en cours...");

        const listIdTicket = this._getListIdTicketSelectionnes();
        const { statutSelectionne } = this.state;

        DataTicket._onEnregistrementStatutTicket(listIdTicket, statutSelectionne).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const state = { statutSelectionne: undefined };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._chargementDonnees);
            }
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });
    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        // KP - 23/06/2023 : la colonne description ne peut être triée car de type NTEXT
        if (sortedColumn !== "description") {
            this._sortedColumn = sortedColumn;
            this._isSortedDescending = isSortedDescending;
            this._chargementDonnees();
        }
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _onSelectionChanged = (items) => {
        this.setState({ itemsSelectionnes: items });
    };

    _supprimerTicket = (idTicket) => () => {
        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Suppression du ticket en cours...");

        DataTicket._onSuppressionTicket(idTicket).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });
    };

    _toggleDialog = (nomDialog, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherDialog${nomDialog}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    _togglePanel = (nomPanel, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    // KP - 23/06/2023 : commenté, chargement pris en charge dans PanelFiltres.componentDidMount
    //componentDidMount = () => {
    //    this._chargementDonnees();
    //};

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this._chargementDonnees();
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const { idTache, match } = this.props;
        const {
            dialogAssignerASelectedOption, dialogEtatSelectedOption, idTacheSelectionne, itemActif, items, statutSelectionne,
            afficherDialogAssignerA, afficherDialogDesaffecter, afficherDialogEtat, afficherDialogStatut, afficherDialogSuppressionTicket,
            afficherPanelFiltres, afficherPanelSelectionProjet, afficherPanelTache, afficherPanelTicket,
        } = this.state;

        return <Fragment>

            {/* KP - 23/06/2023 : migration EUIDetailsList */}
            <EUIDetailsList
                columns={this._columns}
                getKey={item => item.idTicket}
                isSortedDescending={this._isSortedDescending}
                items={items}
                menuItems={this._getItems()}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onFilterButtonClick={this._togglePanel("Filtres", true)}
                onSearch={this._onSearch}
                onSelectionChanged={this._onSelectionChanged}
                selectionMode={SelectionMode.multiple}
                sortedColumn={this._sortedColumn}
            />

            <PanelFiltres
                filtres={this._filtres}
                isOpen={afficherPanelFiltres}
                onValidate={this._appliquerFiltres}
                onDismiss={this._togglePanel("Filtres", false)}
                params={!!match && match.params}
            />

            <FicheTicket
                idTache={idTache || itemActif.itTache}
                idTicket={itemActif.idTicket}
                isOpen={afficherPanelTicket}
                onDismiss={this._togglePanel("Ticket", false)}
                onSave={this._togglePanel("Ticket", false, {}, this._chargementDonnees)}
            />

            <EUIPanel
                headerText="Sélection du projet"
                isFormValid={!!idTacheSelectionne}
                isOpen={afficherPanelSelectionProjet}
                onDismiss={this._togglePanel("SelectionProjet", false)}
                onOpen={() => this.setState({ idTacheSelectionne: undefined })}
                onValidate={this._togglePanel("SelectionProjet", false, {}, this._lierTicketsAProjet)}
                styles={{ content: { height: "100%", padding: 0 } }}
                type={PanelType.smallFluid}
            >
                <DetailsListTache
                    masquerOngletTickets
                    onSelectionTache={(idTache) => this.setState({ idTacheSelectionne: idTache })}
                />
            </EUIPanel>

            <FicheTache
                idTache={itemActif.idTache}
                isOpen={afficherPanelTache}
                masquerOngletTickets
                onDismiss={this._togglePanel("Tache", false)}
                onSave={this._togglePanel("Tache", false)}
            />

            <FicheEnvoiEmail
                idsTickets={this._getListIdTicketSelectionnes()}
                isOpen={this.state.afficherPanelEnvoiEmail}
                onDismiss={this._togglePanel("EnvoiEmail", false)}
                onSend={this._togglePanel("EnvoiEmail", false, {}, this._chargementDonnees)}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="save" onClick={this._toggleDialog("Statut", false, {}, this._modifierStatutTickets)} text="Sauvegarder" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("Statut", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogStatut}
                onDismiss={this._toggleDialog("Statut", false)}
                titre="Modifier statut des tickets"
            >
                {statutSelectionne === 'ouvert'
                    ? "En cliquant sur le bouton Sauvegarder, tous les tickets sélectionnés seront ouverts."
                    : "En cliquant sur le bouton Sauvegarder, tous les tickets sélectionnés seront clôturés."
                }
            </EUIDialog>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="save" onClick={this._toggleDialog("Desaffecter", false, {}, this._dissocierTicketsDeProjet)} text="Dissocier" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("Desaffecter", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogDesaffecter}
                onDismiss={this._toggleDialog("Desaffecter", false)}
                titre="Dissociation de tickets"
            >
                Les tickets sélectionnés seront dissociés de leurs projets respectifs, voulez-vous continuer ?
            </EUIDialog>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="save" onClick={this._toggleDialog("AssignerA", false, {}, this._modifierAssignationTickets)} text="Sauvegarder" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("AssignerA", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogAssignerA}
                onDismiss={this._toggleDialog("AssignerA", false)}
                titre="Assignation de tickets"
            >
                <ComboBoxSalariesScribaNet
                    onChange={(event, option, index, value, item) => this.setState({ dialogAssignerASelectedOption: option })}
                    selectedKey={dialogAssignerASelectedOption.key}
                />
                <MessageBar isMultiline>
                    {
                        dialogAssignerASelectedOption.key === '0'
                            ? "L'assignation de chacun des tickets sélectionnés sera retirée."
                            : "Tous les tickets sélectionnés seront réassignés à " + dialogAssignerASelectedOption.text
                    }<br />
                    Voulez-vous continuer ?
                </MessageBar>
            </EUIDialog>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="save" onClick={this._toggleDialog("Etat", false, {}, this._modifierEtatTickets)} text="Sauvegarder" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("Etat", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogEtat}
                onDismiss={this._toggleDialog("Etat", false)}
                titre="Modifier état des tickets"
            >
                <ComboBoxEtat
                    onChange={(event, option, index, value, item) => this.setState({ dialogEtatSelectedOption: option })}
                    selectedKey={dialogEtatSelectedOption.key}
                />
                <MessageBar isMultiline>
                    Les tickets sélectionnés passeront dans l'état suivant : <strong>{dialogEtatSelectedOption.text}</strong>.<br />
                    Voulez-vous continuer ?
                </MessageBar>
            </EUIDialog>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._toggleDialog("SuppressionTicket", false, {}, this._supprimerTicket(itemActif.idTicket))} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionTicket", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionTicket}
                onDismiss={this._toggleDialog("SuppressionTicket", false)}
                titre="Suppression de ticket"
            >
                Vous êtes en train de supprimer ce ticket, voulez-vous continuer ?
            </EUIDialog>

        </Fragment>;
    }
};

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
        params: {},
    };

    static defaultState = {
        filtreAAffecter: false,
        filtreAssigneA: "0",
        filtreEtats: [],
        filtreIdDomaine: 0,
        filtreIdFonctionnalite: 0,
        filtreStatut: "Tous",
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        const { params } = this.props;
        const { mode, valeur } = params;

        let filtres = { ...PanelFiltres.defaultState };
        if (mode === "Etat") filtres.filtreStatut = valeur;
        if (mode === "AAffecter") filtres.filtreAAffecter = valeur;

        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { isOpen, onDismiss, params } = this.props;
        const { filtreAAffecter, filtreAssigneA, filtreEtats, filtreIdDomaine, filtreIdFonctionnalite, filtreStatut } = this.state;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >

            <Toggle
                defaultChecked={filtreAAffecter}
                disabled={!!params && params.mode === "AAffecter"}
                label="A affecter"
                offText="Tous"
                onChange={(event, checked) => this.setState({ filtreAAffecter: checked })}
                onText="Uniquement"
                required
            />

            <ComboBoxEtat
                multiSelect
                onChange={(event, option, _, value, item) => {
                    const index = filtreEtats.indexOf(option.key);

                    let newFiltreEtats = [...filtreEtats];
                    if (option.selected && index === -1)
                        newFiltreEtats.push(option.key);
                    else newFiltreEtats.splice(index, 1);

                    this.setState({ filtreEtats: newFiltreEtats })
                }}
                selectedKey={filtreEtats}
            />

            <ComboBoxSalariesScribaNet
                onChange={(event, option, index, value, item) => this.setState({ filtreAssigneA: option.key })}
                selectedKey={filtreAssigneA}
            />

            <ChoiceGroup
                options={[
                    { key: 'Tous', text: 'Tous', },
                    { key: 'Ouvert', text: 'Ouvert' },
                    { key: 'Ferme', text: 'Fermé' }
                ]}
                disabled={!!params && params.mode === "Etat"}
                label="Statut"
                onChange={(event, option) => this.setState({ filtreStatut: option.key })}
                required
                selectedKey={filtreStatut}
            />

            <ComboBoxDomaine
                onChange={(event, option, index, value, item) => this.setState({ filtreIdDomaine: option.key, filtreIdFonctionnalite: 0 })}
                selectedKey={filtreIdDomaine}
            />

            <ComboBoxFonctionnalite
                idDomaine={filtreIdDomaine}
                onChange={(event, option, index, value, item) => this.setState({ filtreIdFonctionnalite: option.key })}
                selectedKey={filtreIdFonctionnalite}
            />

        </EUIPanel>;

    };

};